<template>
    <div>
        <v-layout align-center justify-center row fill-height class="mx-0" style="padding: 0">
            <v-spacer></v-spacer>
            <span style="color: #9a9a9a; margin-right: 10px">por página:</span>
            <v-select style=" margin-right: 40px; max-width: 50px; font-size: 14px"
                v-model="byPage"
                :disabled="disabled"
                dense
                @change="onPerPageChange"
                single-row
                :items="Global.ROWS_PER_PAGE"
            ></v-select>
            <span style="color: #9a9a9a; margin-right: 40px">{{description}}</span>

            <span style="color: #9a9a9a; margin-right: 10px">saltar para:</span>
            <v-autocomplete style="max-width: 80px; font-size: 14px; margin-right: 40px"
                v-model="currentPage"
                :disabled="disabled"
                dense
                persistent-hint
                @change="onChange(currentPage)"
                :items="pageJumpList"
            ></v-autocomplete>
            <v-btn small flat icon color="grey darken-1" :disabled="isLastPage || disabled" @click="changePage(-1)">
                <v-icon>chevron_left</v-icon>
            </v-btn>
            <v-btn small flat icon color="grey darken-1" :disabled="isFirstPage || disabled" @click="changePage(+1)">
                <v-icon>chevron_right</v-icon>
            </v-btn>
        </v-layout>
    </div>
</template>

<script>
    import {Global} from "../../config";
    export default {
        name: 'CustomPagination',

        mounted(){
            this.byPage = Global.ROWS_PER_PAGE.length > 0 ? Global.ROWS_PER_PAGE[0] : 5;
        },

        data () {
            return {
                Global,
                pagination: {},
                byPage: 10,
                currentPage: 1,
            }
        },

        props: {
            totalData: Number,
            disabled: {
                type: Boolean,
                default: false,
            }
        },

        methods: {
            onChange(){
                this.consoleLog('emitting');
                this.$emit('onPaginationChange', {
                    byPage: this.byPage,
                    currentPage: this.currentPage,
                });
            },

            onPerPageChange(){
                let lastItem = this.pageJumpList[this.pageJumpList.length-1];
                if(this.currentPage > lastItem){
                    this.currentPage = lastItem;
                }
                this.onChange();
            },

            changePage(value){
                this.currentPage += value;
                this.onChange();
            },

        },

        computed: {
            first(){
                if(this.currentPage === 1) return 1;
                return (this.currentPage - 1) * this.byPage;
            },

            last(){
                let x = this.currentPage * this.byPage;
                return x > this.totalData ? this.totalData : x;
            },

            isFirstPage(){
                return this.currentPage === this.pageJumpList[0];
            },

            isLastPage(){
                return this.currentPage === this.pageJumpList[this.pageJumpList.length-1];
            },

            description(){
                return this.first+' a '+this.last+' de '+this.totalData;
            },

            pageJumpList(){
                let list = [];
                let y = Math.ceil(this.totalData / this.byPage)
                for(let i=y; i>0; i--){
                    list.push(i);
                }
                return list;
            }
        }
    }
</script>